module.exports = __webpack_public_path__ + "static/media/brand-icons.13db00b7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/brand-icons.eot
// module id = 1631
// module chunks = 0